<template>
  <div class="mentionable">
    <div v-if="showPopover" class="tooltip-card" id="userList">
    <div v-for="(user, index) in displayedItems" :key="index" 
      class="tooltip-field" 
      id="userField"
      @mouseover="selectedUser = user.id"
      @mousedown="mentionUser(user)"
    >
      <img
        v-if="user.picture != null"
        :src="load_image(user.picture_small)"
        alt=""
        style="border-radius: 50%"
        width="30"
      />
      <img
        v-else
        src="@/assets/images/users/default.svg"
        alt=""
        style="border-radius: 8px"
        width="30"
      />
      {{ user.firstname+" "+user.lastname }} <small>(@{{user.firstname+user.lastname}})</small>
    </div>
    </div>
    <textarea
      @input="onChange"
      @blur="closePopover()"
      v-model="text"
      class="form-control"
      :placeholder="$t('pages.documents.pdfviewer.write')"
      id="mention-input"
      ref="mention"
      rows="3"
      autofocus
    />
    <button class="btn btn-primary mt-2" @mousedown="sendComment" :disabled="text.length === 0">
      {{ $t('pages.documents.pdfviewer.btn') }}
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "Mentionable",
  props: {
  document: { 
    type: Object,
    required: true
  }
  },
  data() {
  return {
    text: "",
    selectedUser: 0,
    disabled: false,
    searchText: null,
    showPopover: false,
    users: {},
  }
  },
  computed: {
  filteredItems () {
    if (!this.searchText) {
    return this.users
    }
    const searchText = this.searchText.toLowerCase()
    return this.users.filter(item => {
    /** @type {string} */
    let text
    let username = item.firstname+item.lastname;
    if (item.firstname || item.lastname) {
      text = username
    } else {
      text = ''
    }

    return text.toLowerCase().includes(searchText)
    })
  },
  
  mentionedItems() {
    return this.users.filter(item => {
        /** @type {string} */
        let mention;
        let username = '@'+item.firstname+item.lastname;
        let textParts = this.text.split(" ");
        textParts.forEach(element => {
        if(username == element)
        mention = item
        });
        return mention
        })
    },
    displayedItems () {
        return this.filteredItems;
    },
  },
  methods: {
  ...mapActions(["sendNotif"]),
  load_image(picture) {
    return process.env.VUE_APP_IMAGE_URL + picture;
  },
  onChange(event) {
    let str = this.text;
    let messageWords = str.split(" ");
    let lastWord = messageWords[messageWords.length - 1];
    let mentionWord = lastWord.split("");
    if(event.data == '@') {
      this.searchText = null;
      this.showPopover = true;
    }
    else if(mentionWord[0] == '@') {
      mentionWord.shift();
      this.searchText = mentionWord.join("");
      this.showPopover = true;
    }
    else {
      this.closePopover();
    }
  },
  mentionUser(user) {
    let username = user.firstname+user.lastname;
    let textPart = this.text.split(" ");
    textPart.splice(-1, 1, `@${username}`);
    this.text = textPart.join(" ");
    this.searchText = null;
    this.closePopover();
  },
  closePopover() {
    this.showPopover = false;
  },
  sendComment() {
    let users = this.mentionedItems;
    let message = this.text;
    let content = {
    doc_id: this.document.doc_id,
    users: users,
    message: message
    }
    if(message !== "") {
    this.$store.dispatch("saveComment", content).then(() => {
      this.$emit('saved');
    });
    if(users.length !== 0) {
      users.forEach(user => {
        this.notifyUser(user.id);
      })
    }
    this.text = "";
    }
  },
  notifyUser(id) {
    let notifier = JSON.parse(localStorage.getItem('user'));
    let notif = {
      user_id : id,
      title: notifier.name,
      content: 'Vous a mentionné dans un commentaire',
      doc_id: this.document.doc_id,
      mentions: this.mentionedItems
    };
    this.sendNotif(notif);
  }
  },
  created() {
  this.$store.dispatch("getAllUsers").then((response) => {
    this.users = response.data;
  });
  }
}
</script>

<style scoped>

  ::-webkit-scrollbar {
  width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
  background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
  background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
  background: #555;
  }
  .mentionable {
    width: 100%;
  }
  .tooltip-card {
    border-radius: 5px;
    max-height: 150px;
    overflow: scroll;
    overflow-x: hidden;
    -moz-box-shadow: 0 5px 15px #ccc;
    -webkit-box-shadow: 0 5px 15px #ccc;
    box-shadow: 0 0 15px #ccc;
    font-weight: bold;
    position: absolute;
    background-color: white;
    bottom: 140px;
    width: 90%;
    z-index: 100000;
  }

  .tooltip-field {
  padding: 5px;
  }

  .tooltip-field:hover {
    background-color: #071260;
    color: #fff;
    cursor: pointer;
  }
</style>
